export default __webpack_public_path__ + "static/media/voucher.1e126773.svg";